var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"contextmenu",staticClass:"nav flex-column position-absolute bg-white pl-0 border"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('remove')}}},[_vm._v(" "+_vm._s(_vm.$t("general.delete"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }